import { TReduxActions } from '../../types/redux';
import { INewbuildingsStore } from '../../types/newBuldings';
import { ENewBuildingsTypes } from '../../actions';

const initialState: INewbuildingsStore = {
  tabs: [],
  data: { list: [], hash: {} },
  jsonQuery: {},
};

export function newBuildingsReducer(state = initialState, action: TReduxActions) {
  switch (action.type) {
    case ENewBuildingsTypes.NewBuildingsChange:
      return action.payload;
    default:
      return state;
  }
}
